import Color from '@platform-ui/common/utilities/Color.js';
import React from 'react';

export type IconType =
  | 'add'
  | 'adminPanelOutline'
  | 'aiEnabled'
  | 'arrowForward'
  | 'arrowDownward'
  | 'assignment'
  | 'bulkAction'
  | 'calendar'
  | 'cancel'
  | 'checkBox'
  | 'checkBoxOutlineBlank'
  | 'checkCircle'
  | 'checkCircleOutline'
  | 'circle'
  | 'close'
  | 'contentCopy'
  | 'description'
  | 'dollarSign'
  | 'edit'
  | 'errorOutline'
  | 'error'
  | 'fastForward'
  | 'flag'
  | 'filterList'
  | 'gppGoodOutlined'
  | 'help'
  | 'home'
  | 'info'
  | 'infoOutline'
  | 'keyboardArrowDown'
  | 'keyboardArrowUp'
  | 'keyboardArrowLeft'
  | 'keyboardArrowRight'
  | 'language'
  | 'lockOpen'
  | 'logout'
  | 'mail'
  | 'markEmailRead'
  | 'menu'
  | 'money'
  | 'moreDots'
  | 'newApplicant'
  | 'pin'
  | 'pinOutlined'
  | 'profile'
  | 'raisedHandOutlined'
  | 'radioButtonUnchecked'
  | 'referral'
  | 'reportGmailErrorRed'
  | 'save'
  | 'search'
  | 'syncAlt'
  | 'task'
  | 'thumbDown'
  | 'thumbDownOutline'
  | 'thumbUp'
  | 'thumbUpOutline'
  | 'time'
  | 'trash'
  | 'upload'
  | 'UploadDoneOutline'
  | 'pin'
  | 'pinOutlined'
  | 'markEmailRead'
  | 'assignment'
  | 'user'
  | 'unverified'
  | 'verifiedOutlined'
  | 'verified'
  | 'view'
  | 'warning'
  | 'warningOutline';

export type IconProps = {
  type: IconType;
  color?: Color;
  responsiveSize?: 'ResponsiveMD';
  size: 'SM' | 'MD' | 'LG' | 'XL' | 'XXL';
  className?: string;
};

export type Icons = {
  [key in IconType]: React.ElementType;
};

export enum IconSize {
  SM = 'text-xs',
  MD = 'text-base',
  LG = 'text-3xl',
  XL = 'text-6xl',
  ResponsiveMD = 'lg:text-base',
  XXL = 'text-10xl',
}
